import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { CUSTOMER_SEARCH, FRONT_PAGE_PATH, SIGN_OUT_PATH } from '../../constants/paths';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import NOB from '../../constants/language-strings';
import './Header.scss';
import styled from 'styled-components';
import TeliaLogo from '../../images/Telia_Primary_Logo_RGB.png';
import { useSearchStore } from '../../features/customer-search/use-search-store';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import { useWorkOrder } from 'modules/Workorder/api';
import spacing from 'theme/spacing';
const HeaderServiceType = styled.div `
  display: flex;
  align-self: center;
  justify-self: center;
  grid-column-start: 2;
  font-size: 22px;
  font-weight: 500;
  color: ${purpurColorPurple800};
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
const CustomerSearchLink = styled(Link) `
  display: flex;
  align-items: center;
  color: ${purpurColorPurple800};
  font-size: 16px;
  margin-left: ${spacing.spacing16};
  gap: 0.5rem;
  text-decoration: none;
`;
const LogOutLink = styled(Link) `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: ${purpurColorPurple800};
  font-size: 16px;
  margin-right: ${spacing.spacing28};
  gap: 0.5rem;
  text-decoration: none;
`;
const StyledIcon = styled(Icon) `
  color: ${purpurColorPurple800};
`;
const Header = ({ isAuthenticated }) => {
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    const { clear } = useSearchStore();
    const previousPath = pathname.substring(0, pathname.lastIndexOf('/'));
    const isWorkOrderPath = matchPath({ path: '/workOrder/:id/*' }, pathname);
    const isAuthenticatedAndInWorkOrder = isAuthenticated && isWorkOrderPath;
    const match = pathname.match(/\/workOrder\/(\d+)/);
    const workOrderId = match ? Number(match[1]) : 0;
    const { workOrder, workOrderErrorMessage } = useWorkOrder(workOrderId);
    const onGoBackClicked = (e) => {
        e.preventDefault();
        navigate(-1);
    };
    const workOrderHeader = (_jsxs("div", { className: "header", children: [workOrderErrorMessage === '' && _jsx(HeaderServiceType, { children: workOrder === null || workOrder === void 0 ? void 0 : workOrder.serviceTypeName }), _jsx(Link, { className: "header__button-back", to: previousPath === '/workOrder' ? '/' : previousPath, children: _jsx(StyledIcon, { svg: icons.arrowLeft, size: "lg" }) })] }));
    const customerInfoHeader = (_jsxs("div", { className: "header", children: [workOrderErrorMessage === '' && _jsx(HeaderServiceType, { children: "Kunde" }), _jsx("a", { className: "header__button-back", onClick: onGoBackClicked, href: "#", children: _jsx(StyledIcon, { svg: icons.arrowLeft, size: "lg" }) })] }));
    const defaultHeader = (_jsxs("div", { className: "header", children: [isAuthenticated && (_jsxs(CustomerSearchLink, { to: CUSTOMER_SEARCH, onClick: () => clear(), children: [_jsx(StyledIcon, { svg: icons.search, size: "md" }), "Kundes\u00F8k"] })), _jsx(Link, { className: "header__logo", to: FRONT_PAGE_PATH, children: _jsx("img", { src: TeliaLogo, alt: "Telia logo", className: "header__logo" }) }), isAuthenticated && (_jsxs(LogOutLink, { to: SIGN_OUT_PATH, children: [_jsx(Icon, { svg: icons.logout }), NOB.HEADER.LOGOUT] }))] }));
    const headerToRender = (() => {
        if (!isAuthenticated)
            return defaultHeader;
        if (isAuthenticatedAndInWorkOrder)
            return workOrderHeader;
        if (pathname.includes('customerInfo'))
            return customerInfoHeader;
        return defaultHeader;
    })();
    return _jsx("div", { children: headerToRender });
};
const mapStateToProps = (state) => ({
    isAuthenticated: state.authentication.isAuthenticated,
});
export default connect(mapStateToProps)(Header);
